/**
 * This service gives access to the current
 * environment settings like the ones passed
 * to the FE through the window.Arrow object
 *
 */
// TODO: DT - move places that use the global Arrow to use this service
export class EnvironmentService {
  getBuildVersion() {
    return Arrow.buildVersion;
  }
  getTranslationsCacheKey() {
    return Arrow.translationsCacheKey;
  }
}

export const environmentService = new EnvironmentService();



// WEBPACK FOOTER //
// ./assets/services/EnvironmentService.js